import React, { useState, useEffect } from 'react'

// Components
import Nav from '../../components/menu/'

// Libraries
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'

// Images
import Image1 from '../../assets/images/hero/hero-image-1.png'
import Image12X from '../../assets/images/hero/hero-image-1@2x.png'
import Image2Mobile from '../../assets/images/hero/hero-image-2-mobile.png'
import Image2Mobile2X from '../../assets/images/hero/hero-image-2-mobile@2x.png'
import Image3 from '../../assets/images/hero/hero-image-3.png'
import Image32X from '../../assets/images/hero/hero-image-3@2x.png'
import { Trans } from 'react-i18next'

// Icons
import { ReactComponent as IconBack } from '../../assets/icons/Back.svg'
import { ReactComponent as IconNext } from '../../assets/icons/Next.svg'

const ArrowBack = (props) => {
  return (
    <button className={props.className} onClick={props.onClick}>
      <IconBack />
    </button>
  )
}

const ArrowNext = (props) => {
  return (
    <button className={props.className} onClick={props.onClick}>
      <IconNext />
    </button>
  )
}

const Hero = () => {
  // ANIMACIÓN
  // Si este estado es true, en Desktop mostramos todas las imagenes.
  // Si es false, no las mostramos.
  const [showAllImages, setShowAllImages] = useState(false)

  const carouselConfig = {
    infinite: true,
    dots: false,
    // arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: <ArrowBack />,
    nextArrow: <ArrowNext />
  }

  // Agregamos el oyente del scroll
  useEffect(() => {
    const handleScroll = () => {
      const image = document.getElementById('heroImg')
      const imageSize = 352
      const windowWidth = window.innerWidth
      const scrollPosition = window.scrollY

      let delta = (windowWidth - scrollPosition) / imageSize

      if (delta > 1 && showAllImages) {
        setShowAllImages(false)
      }

      if (delta <= 1 && !showAllImages) {
        delta = 1 // Redondeo
        setShowAllImages(true)
      }

      if (scrollPosition <= windowWidth && delta >= 1) {
        if (image) {
          image.style.transform = 'scale(' + delta + ')'
        }
      }
    }

    document.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()

    return () => document.removeEventListener('scroll', handleScroll)
  })

  return (
    <section className="hero">
      <div className="container">
        <div className="hero__scrolling-area">
          <div className="area">
            <Nav />
            <div className="hero__title text-center">
              <h2 className="font-weight--300">
                <Trans i18nKey="hero.upperTitle" />
              </h2>
              <h1 className="font-weight--500">
                <Trans i18nKey="hero.lowerTitle" />
              </h1>
            </div>

            {/* Mobile Carousel:start */}
            <Slider className="hero__carousel d-md-none" {...carouselConfig}>
              <div>
                <img src={Image1} srcSet={Image12X + ' 2x'} alt="Margot" />
              </div>
              <div>
                <img src={Image2Mobile} srcSet={Image2Mobile2X + ' 2x'} alt="Margot" />
              </div>
              <div>
                <img src={Image3} srcSet={Image32X + ' 2x'} alt="Margot" />
              </div>
            </Slider>
            {/* Mobile carousel:end */}

            {/* Desktop images with animation:start */}
            <div className="hero__images d-none d-md-flex justify-content-center">
              <img className={showAllImages ? 'img visible' : 'img'} src={Image1} srcSet={Image12X + ' 2x'} alt="Margot" />
              <div id="heroImg" className="img visible img__animated"></div>
              <img className={showAllImages ? 'img visible' : 'img'} src={Image3} srcSet={Image32X + ' 2x'} alt="Margot" />
            </div>
            {/* Desktop images with animation:end */}
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-12 col-sm-10">
            <div className="hero__description text-center">
              <p className="title font-weight--600">
                <Trans i18nKey="hero.subtitle" />
              </p>

              <p className="paragraph--large">
                <Trans i18nKey="hero.content" />
              </p>

              <a className="button d-md-none" href="https://wa.me/5493425662175" target="_blank" rel="noopener noreferrer">
                <Trans i18nKey="components.ctaLabel" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
